var _path, _path2, _g, _path3, _path4, _path5, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtSessions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33324 11C8.95101 11 10.2666 9.68444 10.2666 8.06666C10.2666 6.44889 8.95101 5.13333 7.33324 5.13333C5.71546 5.13333 4.3999 6.44889 4.3999 8.06666C4.3999 9.68444 5.71546 11 7.33324 11Z",
    fill: "#FFE082"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1941 12.057C9.96637 11.8608 9.64124 11.8257 9.37555 11.9639C8.12373 12.6213 6.54248 12.6213 5.29066 11.9639C5.02497 11.8257 4.69912 11.8608 4.4721 12.057C3.49385 12.8978 2.93311 14.1159 2.93311 15.4V16.1333C2.93311 16.5387 3.2611 16.8667 3.66644 16.8667H10.9998C11.4051 16.8667 11.7331 16.5387 11.7331 16.1333V15.4C11.7331 14.1159 11.1724 12.8978 10.1941 12.057Z",
    fill: "#42A5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2668 8.06666C10.2668 9.6873 8.95413 11 7.3335 11V5.13333C8.95413 5.13333 10.2668 6.44603 10.2668 8.06666Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7335 15.4V16.1333C11.7335 16.5365 11.4034 16.8666 11.0002 16.8666H7.3335V12.4523C8.04463 12.4523 8.75648 12.2905 9.37952 11.9603C9.64378 11.8286 9.96605 11.8579 10.1938 12.0563C11.1763 12.8992 11.7335 14.1166 11.7335 15.4Z",
    fill: "black"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7854 10.4816L17.3854 6.08155C17.1755 5.87172 16.8597 5.8087 16.5861 5.92257C16.3118 6.03572 16.1335 6.30356 16.1335 6.60004V8.80004H13.9335C13.5282 8.80004 13.2002 9.12804 13.2002 9.53337V12.4667C13.2002 12.872 13.5282 13.2 13.9335 13.2H16.1335V15.4C16.1335 15.6965 16.3118 15.9644 16.5861 16.0775C16.6771 16.1155 16.7723 16.1334 16.8669 16.1334C17.0574 16.1334 17.245 16.0589 17.3854 15.9185L21.7854 11.5185C22.0718 11.2321 22.0718 10.768 21.7854 10.4816Z",
    fill: "#EF5350"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M21.7874 11.5206L17.6001 15.7079V6.29205L21.7874 10.4794C22.0731 10.7651 22.0731 11.2349 21.7874 11.5206Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 22H2.93333C1.31556 22 0 20.6844 0 19.0667V2.93333C0 1.31556 1.31556 0 2.93333 0H11C11.4053 0 11.7333 0.327995 11.7333 0.733333C11.7333 1.13867 11.4053 1.46667 11 1.46667H2.93333C2.1248 1.46667 1.46667 2.1248 1.46667 2.93333V19.0667C1.46667 19.8752 2.1248 20.5333 2.93333 20.5333H11C11.4053 20.5333 11.7333 20.8613 11.7333 21.2667C11.7333 21.672 11.4053 22 11 22Z",
    fill: "#FFCA28"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7335 21.2667C11.7335 21.6698 11.4034 22 11.0002 22H7.3335V20.5333H11.0002C11.4034 20.5333 11.7335 20.8635 11.7335 21.2667Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 1.46667H7.3335V0H11.0002C11.4034 0 11.7335 0.330143 11.7335 0.733333C11.7335 1.13652 11.4034 1.46667 11.0002 1.46667Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtSessions);
export default __webpack_public_path__ + "static/media/ATSessions.0e06020213eeced988fbebebd5d5dfc6.svg";
export { ForwardRef as ReactComponent };